export const BASE_URL =
  process.env.REACT_APP_API_BASE_URL || 'https://api.hanyu.io';
